import React from 'react';
import { withRouter } from 'react-router-dom';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import FacebookLogin from '../../../components/auth/FacebookLogin';
import YoutubeLogin from '../../../components/auth/YoutubeLogin';

import { getInfluencerProfile, updateInfluencerProfile } from '../../../api_handlers/influencer.js';
import { authHandlers } from '../../../api_handlers/auth';

class ConnectSocialMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isInstagramLinked: false,
      isYoutubeLinked: false,
    };
  }

  updateInstagramConnection() {
    this.setState({
      isInstagramLinked: true,
    });
    updateInfluencerProfile({
      is_instagram_linked: true,
    });
  }

  updateYoutubeConnection() {
    this.setState({
      isYoutubeLinked: true,
    });
    updateInfluencerProfile({
      is_youtube_linked: true,
    });
  }

  async registerToBackendFacebook(data) {
    const user = await authHandlers.facebookLogin(data);
    if (user) this.updateInstagramConnection();
  }

  async registerToBackendYoutube(data) {
    const user = await authHandlers.youtubeLogin(data);
    if (user) this.updateYoutubeConnection();
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    const influencerData = await getInfluencerProfile();
    this.setState({
      isInstagramLinked: influencerData.is_instagram_linked,
      isYoutubeLinked: influencerData.is_youtube_linked,
    });
  }

  render() {
    return (
      <div className="inf-connect">
        <div className="inf-connect-row">
          <FacebookLogin
            label="Connect your Facebook page"
            is_linked={this.state.isInstagramLinked}
            onSuccess={(response) => {
              this.registerToBackendFacebook(response);
            }}
          />
          {this.state.isInstagramLinked ? (
            <span className="inf-connected">
              <CheckCircleIcon style={{ fontSize: 18 }} />
              Connected
            </span>
          ) : null}
        </div>
        <div className="inf-connect-row">
          <YoutubeLogin
            label="Connect your Youtube Account"
            is_linked={this.state.isYoutubeLinked}
            onSuccess={(response) => {
              this.registerToBackendYoutube(response);
            }}
          />
          {this.state.isYoutubeLinked ? (
            <span className="inf-connected">
              <CheckCircleIcon style={{ fontSize: 18 }} />
              Connected
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}

export default withRouter(ConnectSocialMedia);
